<template>
		<div class="modal" ref="modalz">
			<div class="modal-content"> 
				<button class="close-btn modal-close white btn-floating waves-effect">
					<i class="material-icons grey-text text-darken-3">
						close
					</i>
				</button>
				<div class="impact-card ">
					<div >
						<div class="modal-title"	:style="[{ color: dataCardInfo.backgroundColor }]"	v-html="dataCardInfo.name">	</div>
						<div class="section-label">	</div>
						<div class="desc" v-html="dataCardInfo.definition"></div>
						<div class="section-label">
							Example
						</div>
						<div class="desc" v-html="dataCardInfo.example"></div>
						<div class="section-label">
						Selection Guidance
						</div>
						<div class="desc" v-html="dataCardInfo.guidance"></div>
					
					</div>
				</div>
			</div>
		</div>

</template>
<script>
import M from 'materialize-css'
export default {
	name: 'ImpactLevelCard',
	props: {
    showSelect:{
      type: Boolean,
      default: false,
    },
		dataCardInfo: {
			type: Object,
			default: () => ({}),
		},
		dataSelectedScore: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			selectedTab: "definition",
			justification: "",
			showModal: false,
			modal: {
				instance: null,
				options: {
					startingTop:'50%',
					endingTop: '10%',
					onCloseEnd:() =>{
						this.$emit('terminate')
					}
				},
			},
			// selectedScore: "",
		};
	},
	mounted() {
		setTimeout(() => {
			this.initializeModal()
		}, 300);
		if (!this.dataSelectedScore.selected) return;
		if (this.dataSelectedScore.selected === this.dataCardInfo.name)	this.justification = this.dataSelectedScore.justification;
		
	},
	computed: {},
	beforeDestroy() {
		//return this.modal.instance !== null ? this.modal.instance.destroy() : false;
	},
	methods: {
		initializeModal () {
			this.modal.instance = M.Modal.init(this.$refs.modalz, this.modal.options)
			setTimeout(() => {
				this.modal.instance.open()
			}, 100);
		},
    showTextOption (){
      this.$emit('choice', this.dataCardInfo.name)
    },
		$_openModal() {
			this.showModal = true;

			setTimeout(() => {
				this.modal.instance = M.Modal.init(
					this.$refs.modalz,
					this.modal.options
				);
				this.modal.instance.open();
			}, 10);

			setTimeout(() => {
				M.updateTextFields();
			});
		},

		$_closeModal() {
			this.modal.instance.close();
			this.modal.instance.destroy();
			this.showModal = false;
		},
		$_confirm() {
			this.$emit("updateJustification", {
				selected: this.dataCardInfo.name,
				justification: this.justification,
			});
			this.$_closeModal();
			//  this.showModal = false;
			//   setDocumentBodyOverflowProperty("auto");
		},
	},
};
</script>
<style lang="scss" scoped>
.modal {
	max-width: 690px;
	border-radius: 8px;
}
.modal-title {
	font-size: 20px;
	margin-bottom: 6px;
	font-weight: 600;;
}
.section-label {
	font-size: 17px;
	letter-spacing: 1px;
	font-weight: 600;
	margin: 10px 0 3px;
}
.close-btn {
	position: absolute;
	right: 10px;
	top: 12px;
}
</style>
